/* eslint-disable import/prefer-default-export */
import pathToRegexp from 'path-to-regexp'
import { WebRoute, AppRoute } from '../types/core'
import { addQueryString, basePathUrl } from './url'

const compilePath = (path) => {
  const keys = []
  const regexp = pathToRegexp(path, keys)
  return { regexp, keys }
}

export const configureSegment = (pathSegment: string) => (pathnameSegment: string) => {
  const { regexp, keys } = compilePath(pathSegment)
  const match = regexp.exec(pathnameSegment)

  let segment: string = ''
  let values: string[] = []

  if (match) {
    ;[segment, ...values] = match
  }

  const isExact: boolean = pathnameSegment === segment

  return {
    path: pathSegment,
    isExact,
    url: pathSegment === '/' && segment === '' ? '/' : segment,
    params: keys.reduce((memo, key, index) => {
      return {
        ...memo,
        [key.name]: values[index],
      }
    }, {}),
  }
}

export function isWebRoute(route: AppRoute): route is WebRoute {
  return !('as' in route)
}

// Next.js automatically prepends the basePath config when navigating via next/router or next/link.
// If we are converting a NextRoute to a WebRoute for a hard load, we need to do this ourselves.
// If the route is already a WebRoute, we assume that it is ready for a hard load.
export const toWebRoute = (route: AppRoute): WebRoute =>
  isWebRoute(route) ? route : { href: route.as }

export const routeToHref = (route: AppRoute) => {
  const { href: routeHref } = toWebRoute(route)
  return /^http/.test(routeHref) ? routeHref : basePathUrl(routeHref)
}

export const addQueryStringToRoute = (
  route: AppRoute,
  query: { [key: string]: string }
): AppRoute => {
  const href = addQueryString(route.href, query || {})

  if (isWebRoute(route)) {
    return { href }
  }
  const as = addQueryString(route.as, query || {})
  return { href, as }
}

export const addRedirectQueryToRoute = (
  route: AppRoute,
  redirectHref: string
): AppRoute => {
  if (!redirectHref) return route
  const redirect = encodeURIComponent(redirectHref)
  const newRoute = addQueryStringToRoute(route, { redirect })
  return newRoute
}

export const matchSourceSegmentCTFM = configureSegment(
  ':source([^/]+?):page(autociteeval|autociteconfirm|manualcite)'
)

export const FORM_PAGE = {
  NEW: 'autociteconfirm',
  EVAL: 'autociteeval',
  MANUAL: 'manualcite',
} as const
